import React, { useState } from "react";
import Button from "../../Elements/Button/Button";

// Diálogo de confirmación para borrar
const Confirmar = ({ mensaje, detalle, textoConfirmar = "Eliminar", onConfirm, cerrar }) => {
  const [enviando, setEnviando] = useState(false);

  const confirmar = async () => {
    setEnviando(true);
    const ok = await onConfirm();
    setEnviando(false);
    if (ok !== false) cerrar();
  };

  return (
    <div className="pp-confirmar">
      <div className="pp-confirmar-icono">
        <i className="bi bi-exclamation-octagon" />
      </div>
      <p className="pp-confirmar-mensaje">{mensaje}</p>
      {detalle && <p className="pp-confirmar-detalle">{detalle}</p>}
      <div className="pp-form-acciones">
        <Button text="Cancelar" color="gray" action={cerrar} disabled={enviando} padding />
        <Button text={enviando ? "Eliminando…" : textoConfirmar} color="red" fill action={confirmar} disabled={enviando} padding />
      </div>
    </div>
  );
};

export default Confirmar;
